import { AfterContentInit, Component, ElementRef, HostBinding, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Floating label do Material (recria o `ion-label position="floating"` do Ionic sem Ionic).
 * O rótulo projetado (via `[mpFloatingLabelText]`) fica DENTRO do campo como placeholder e
 * SOBE (flutua) quando o input está FOCADO ou tem VALOR — estado exposto pela classe de
 * host `mp-floating--floated`.
 *
 * Uso:
 *   <mp-floating-label>
 *     <span mpFloatingLabelText><ion-icon name="search-outline"></ion-icon> Pesquisar</span>
 *     <input class="mp-input" ...>
 *   </mp-floating-label>
 */
@Component({
	selector: 'mp-floating-label',
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="mp-floating-label__label"><ng-content select="[mpFloatingLabelText]"></ng-content></div>
		<ng-content></ng-content>
	`,
	styleUrls: ['./mp-floating-label.component.scss'],
})
export class MpFloatingLabelComponent implements AfterContentInit {
	private focused = false;
	private hasValue = false;

	constructor(private host: ElementRef<HTMLElement>) {}

	@HostBinding('class.mp-floating--floated')
	get floated(): boolean {
		return this.focused || this.hasValue;
	}

	/** Só o FOCO pinta o rótulo na cor primária; flutuado por ter valor, ele fica preto (como no Ionic). */
	@HostBinding('class.mp-floating--focused')
	get isFocused(): boolean {
		return this.focused;
	}

	ngAfterContentInit(): void {
		// campos pré-preenchidos já entram flutuando
		this.updateValue();
	}

	@HostListener('focusin')
	onFocus(): void {
		this.focused = true;
	}

	@HostListener('focusout')
	onBlur(): void {
		this.focused = false;
		this.updateValue();
	}

	@HostListener('input')
	onInput(): void {
		this.updateValue();
	}

	private updateValue(): void {
		const control = this.host.nativeElement.querySelector<HTMLInputElement>('input, textarea, select');
		this.hasValue = !!(control && control.value);
	}
}
